import { LocalStorageAPI } from 'API/LocalStoreApi';
import { eLocalStorageTags } from 'API/eLocalStorageTags';

export const VisitTrackingAPI = LocalStorageAPI.injectEndpoints({
  endpoints: (build) => ({
    getLastVisited: build.query<string, string>({
      query: (id) => ({ url: `order-${id}`, method: 'GET' }),
      providesTags: (result, error, id) => [{ type: eLocalStorageTags.OrderLastVisit, id }],
    }),
    setLastVisited: build.mutation<void, { id: string; body: string }>({
      query: ({ id, body }) => ({
        url: `order-${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: eLocalStorageTags.OrderLastVisit, id }],
    }),
  }),
});

export const { useGetLastVisitedQuery, useSetLastVisitedMutation } = VisitTrackingAPI;
